import React, { Component } from 'react';

import ScoreBar from './components/ScoreBar';

import './ScoreList.scss';

const averageScore = (entry) => {
  if (entry.children.length === 0) return 'N/A';

  return Math.round((entry.children.reduce((acc, cur) => {
    return acc + parseFloat(cur.skill_scores.reduce((acc2, cur2) => {
      return acc2 + parseFloat(cur2.skill_score);
    }, 0));
  }, 0) / entry.children.length) * 100) / 100;
};

const scoreColor = (entry) => {
  if (isNaN(averageScore(entry))) return 'text-primary';

  if (averageScore(entry) < 34) {
    return 'text-danger';
  } else if (averageScore(entry) < 67) {
    return 'text-warning';
  } else {
    return 'text-success';
  }
};

class ScoreList extends Component {
  render() {
    return (
      <div className='progress-report-score-list'>
        <div className='progress-report-score-list__list'>
          {this.props['student-report-data'].skills.map((entry, index) => (
            <div className='row progress-report-score-list__entry' key={entry.id}>
              <div className='col-md-5'>
                <div className='progress-report-score-list__entry-summary'>
                  <h5 className='progress-report-score-list__entry-title'>{entry.skill_name}</h5>
                  <p className='progress-report-score-list__score'><span className={scoreColor(entry)}>{Math.round(averageScore(entry)) || 'N/A'}</span></p>
                  <p className='progress-report-score-list__score-fraction'>out of 100</p>
                  <p className='progress-report-score-list__description'>{entry.skill_description}</p>
                </div>
              </div>
              <div className='col-md-7'>
                {entry.children.map((score) =>
                  <ScoreBar entry={score} key={score.id} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

ScoreList.defaultProps = {
};

export default ScoreList;



// WEBPACK FOOTER //
// ./src/routes/progress-report/routes/ProgressReport/components/ProgressReport/components/ScoreList/index.js